import { useEffect, useState } from "react";
import { Row, Col } from "antd";
import { Get } from "../../config/api/get";
import { FARE, RATE } from "../../config/constants/api";
import { useSelector } from "react-redux";
import { useLocation } from "react-router";
import "./payment.css";
import PaymentComponent from "../../components/PaymentComponent";
function Payment(props) {
  const location = useLocation();
  const total = location?.state?.total;
  const type = location?.state?.type;
  const bookingId = location?.state?.bookingId;
  const booking = location?.state?.booking;
  const planId = location?.state?.planId;
  const details = location?.state?.details;
  const passengerCapacity = location?.state?.passengerCapacity;
  const [paymentProfileId, setPaymentProfileId] = useState(null);
  // const [paymentMethods, setPaymentMethods] = useState(null);
  const [latestRate, setLatestRate] = useState(null);
  const [latestFare, setLatestFare] = useState(null);
  const token = useSelector((state) => state.user.userToken);

  // const handleCardSelect = (paymentProfileId) => {
  //   setPaymentProfileId(paymentProfileId);
  // };
  const getLatestRate = async () => {
    Get(RATE.getLatestRate, token, { serviceType: booking?.serviceType })
      .then((response) => {
        if (response?.status) {
          setLatestRate(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  const getLatestFare = async () => {
    Get(FARE.getLatestFare, token, { serviceType: booking?.serviceType })
      .then((response) => {
        if (response?.status) {
          setLatestFare(response?.data);
        }
      })
      .catch((err) => {
        console.log("error", err);
      });
  };
  useEffect(() => {
    getLatestRate();
    getLatestFare();
    setPaymentProfileId(null)
    // eslint-disable-next-line
  }, []);
  const getHourlyRate = () => {
    if (latestRate) {
      return latestRate?.hourlyRate;
    }
    return 0;
  };
  const getPerMileRate = () => {
    if (latestFare) {
      return latestFare?.farePerMile;
    }
    return 0;
  };
  // const getPaymentProfiles = async () => {
  //   Get(PAYMENT.getPaymentProfiles, token)
  //   .then((response) => {
  //     if (response?.status) {
  //         setPaymentMethods(response?.data?.paymentProfiles);
  //       }
  //     })
  //     .catch((err) => {
  //       console.log(err, "Error fetching payment methods");
  //     });
  // };
  // useEffect(() => {
  //     getPaymentProfiles();
  // }, []);

  return (
    <div style={{ overflow: "hidden" }}>
      <Row gutter={[16, 16]} justify={"center"} align={"middle"}>
        <Col lg={24} style={{ textAlign: "center", padding: "20px 0" }}>
          <h1
            className="font-bold font-goldman xldesktop:text-[22px] laptop:text-[16px] "
            style={{ color: "black" }}
          >
            CHECKOUT & PAYMENT
          </h1>
        </Col>
        <Col lg={22}>
          {/* {Array.isArray(paymentMethods) && paymentMethods?.length > 0 && (
            <PaymentMethods
              paymentMethods={paymentMethods}
              onSelect={handleCardSelect}
            />
          )} */}
          <div className="">
            <Row>
              <Col lg={10} md={12} sm={24} xs={24}>
              {booking && (
              <div
                className="card-item-flex member-cards member-card-center"
                style={{
                  border: "2px solid #000",
                  padding: "10px",
                  borderRadius: "12px",
                  // width: "80%",
                  fontWeight: "bold",
                  // boxShadow: "1px 2px 2px #000",
                  color: "black",
                }}
              >
                <h5 className="font-goldman text-customGold xldesktop:text-[22px] laptop:text-[16px] leading-8 font-semibold">
                  Pricing Breakdown:
                </h5>
                {booking?.duration ? (
                <>
                  <span className="text-[#000] font-semibold pt-2">
                    Hourly Rate: ${getHourlyRate()} per hour
                  </span>
                  <p className="font-euclid text-sm lg:text-base max-sm:text-xs text-[#666] font-bold transition-colors">
                    Total for {booking?.duration} hours: {booking?.duration}{" "}
                    hours × ${getHourlyRate()}/hour = $
                    {getHourlyRate() * booking?.duration}
                  </p>
                </>
                ) : null}
                {booking?.initialMileage ? (
                  <>
                    <span className="text-[#000] font-semibold pt-2">
                      Mileage Fee:
                    </span>
                    <p className="font-euclid text-sm  lg:text-base max-sm:text-xs text-[#666]  font-bold transition-colors">
                      {booking?.serviceType} Luxury: ${getPerMileRate()} per
                      mile
                    </p>
                    <p className="font-euclid text-sm lg:text-base max-sm:text-xs text-[#666]  font-bold transition-colors">
                      Total for {booking?.initialMileage.toFixed(2)} miles:{" "}
                      {booking?.initialMileage.toFixed(2)} miles × $
                      {getPerMileRate()}/mile = $
                      {(
                        booking?.initialMileage.toFixed(2) * getPerMileRate()
                      ).toFixed(2)}
                    </p>
                  </>
                ) : (
                  <></>
                )}
                <h4 className="font-goldman text-customGold xldesktop:text-[24px] laptop:text-[24px] leading-10 font-semibold">
                  To Pay : ${booking?.initialCharges}
                </h4>
              </div>
            )}
              </Col>
              <Col lg={12} md={12} sm={24} xs={24}>
              <div className="payment-body">
              <PaymentComponent
                amount={total}
                type={type}
                bookingId={bookingId}
                planId={planId}
                paymentProfileId={paymentProfileId}
                details={details}
                serviceType={booking?.serviceType}
                passengerCapacity={passengerCapacity}
              />
            </div>
              </Col>
            </Row>
            
            
          </div>
        </Col>
      </Row>
    </div>
  );
}

export default Payment;
